export default "__VITE_ASSET__c1b6da1c__"